module.exports = __webpack_public_path__ + "static/photos@2x-c7ec6dec790e7d90f98a7a89a6bee5ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/photos@2x.jpg
// module id = 2724
// module chunks = 168707334958949